import { useQuery } from '@tanstack/react-query';
import eduzzAccountsService from 'v2/services/eduzzAccount';

export function useGetSunBetaModules(enabled: boolean) {
  return useQuery({
    queryKey: ['sun-beta-modules'],
    queryFn: () => eduzzAccountsService.getSunBetaModules(),
    enabled,
    staleTime: 5 * 60 * 1000
  });
}
